import { Image, Pressable, useWindowDimensions, Dimensions, StyleSheet, Text, View } from 'react-native'
import React, { useEffect, useRef, useState } from 'react'
import Ionicons from '@expo/vector-icons/Ionicons';
import Animated, { Transition, withTiming, withDelay, Easing, SlideInUp ,FadeInDown, FadeOut, useAnimatedStyle, withSpring, useSharedValue } from 'react-native-reanimated';
import { LinearGradient } from 'expo-linear-gradient';
import { colors } from '../../colors';
import { displayFont } from '../../fonts';
import { Video, AVPlaybackStatus } from 'expo-av';
import {screen} from '../../utils'

const ReanimatedPressable = Animated.createAnimatedComponent(Pressable);
const defaultScreenRatio = Dimensions.get("window").width / Dimensions.get("window").height;

const Cards = ({isTop, index, genre, url, name, posterUrl, titleCardUrl, setVideoUrl, setIsVisible, hoveredIndex, onHoverIndex, featured, rail}) => {
  const window = useWindowDimensions();
  const narrow = window.width < 768;
  const [isExpanded, setIsExpanded] = useState(false);
  const [isFill, setIsFill] = useState(false);
  const [status, setStatus] = useState({});
  const flexValue = useSharedValue(1);
  const opacityVal = useSharedValue(0);
  const dimVal = useSharedValue(1);
  const videoWidth = useSharedValue(0);
  const videoHeight = useSharedValue(0);
  const buttonOpacity = useSharedValue(0);
  const titleSkew = useSharedValue(0);
  const titleScale = useSharedValue(0.5);
  const video = useRef(null);
  const opacityValue = useSharedValue(0.4);

  // Use the screenDefaultRatio to render the video before the video is loaded
    const [videoRatio, setVideoRatio] = useState(defaultScreenRatio);

    // Update the videoRatio right after we know the video natural size
    const updateVideoRatioOnDisplay = (videoDetails) => {
        const { width, height } = videoDetails.naturalSize;
        const newVideoRatio = width / height;

        setVideoRatio(newVideoRatio);
    }

  const animatedStyles = useAnimatedStyle(() => {
    return {
      flex: flexValue.value,
      opacity: opacityVal.value * dimVal.value,
    //   width: videoWidth.value,
    //   height: videoHeight.value,
    };
  });

  const animatedButtonStyles = useAnimatedStyle(() => {
    return {
      opacity: buttonOpacity.value,
      zIndex: 4,
      transform: [{ skewX: narrow ? '0deg' : '12deg' }],
    };
  });

  const animatedTitleStyles = useAnimatedStyle(() => {
    return {
      transform: [
        { skewX: `${titleSkew.value}deg` },
        { scale: titleScale.value },
      ],
    };
  });

//   const animatedImageStyles = useAnimatedStyle(() => {
//     return {
//       width: posterWidth.value,
//       height: posterHeight.value,
//     };
//   });

  const animatedMaskStyles = useAnimatedStyle(() => {
    return {
      opacity: opacityValue.value
    };
  });

  const expandCard = () => {
    setIsExpanded(true);
    setVideoUrl(url);
    onHoverIndex && onHoverIndex(index);
    flexValue.value = withTiming(2.8, {duration: 280, easing: Easing.out(Easing.cubic)});
    titleSkew.value = withTiming(12, {duration: 280, easing: Easing.out(Easing.cubic)});
    titleScale.value = withTiming(1.08, {duration: 280, easing: Easing.out(Easing.cubic)});
    buttonOpacity.value = withDelay(500, withTiming(1));
    opacityValue.value = 0;
  }

  const collapseCard = () => {
    setIsExpanded(false);
    // setStatus({});
    flexValue.value = withSpring(1);
    titleSkew.value = withTiming(0, {duration: 220});
    titleScale.value = withTiming(0.5, {duration: 220});
    buttonOpacity.value = 0;
    opacityValue.value = 0.4;

  }

  const pressCard = () => {
    setIsFill(true);
    setVideoUrl(url);
    setIsVisible(true);
    // videoWidth.value = withSpring(window.width);
    // videoHeight.value = withSpring(window.height);
    // posterHeight.value = withTiming(window.height);
    // posterWidth.value = withTiming(window.width);
  }

  useEffect(()=>{
    opacityVal.value = withDelay(300 * index, withTiming(1, {duration: 1000,easing: Easing.linear}));
    if (narrow) {
      buttonOpacity.value = 1;
      titleSkew.value = 0;
      titleScale.value = 1;
    }
  }, []);

  useEffect(() => {
    if (narrow || hoveredIndex == null || hoveredIndex === index) {
      dimVal.value = withTiming(1, {duration: 220});
    } else {
      dimVal.value = withTiming(0.4, {duration: 220});
    }
  }, [hoveredIndex, narrow, index]);


  if (narrow && featured) {
    return (
      <Pressable accessibilityRole="button" accessibilityLabel={`Watch trailer for ${name || genre}`} onPress={pressCard} style={styles.featured}>
        <View style={[styles.featuredImage, { height: window.height * 0.72 }]}>
          <LinearGradient
            colors={['transparent', 'transparent', 'rgba(0,0,0,0.45)', 'transparent']}
            locations={[0, 0.42, 0.78, 1]}
            style={styles.heroFade}
          />
          <View style={styles.heroCopy}>
            <Text style={styles.heroGenre}>{genre}</Text>
            {!!titleCardUrl && <Image accessibilityLabel={name || genre} resizeMode="contain" style={styles.featuredTitle} source={{uri: `https://ivyooo.com/assets/images/${titleCardUrl}`}} />}
            <View style={styles.featuredButton}>
              <Ionicons name="play-circle-outline" size={26} color={colors.white} />
              <Text style={styles.trailerText}>WATCH TRAILER</Text>
            </View>
          </View>
        </View>
      </Pressable>
    )
  }

  if (narrow && rail) {
    return (
      <Pressable accessibilityRole="button" accessibilityLabel={`Watch trailer for ${name || genre}`} onPress={pressCard} style={styles.thumb}>
        {!!posterUrl && <Image accessibilityLabel="" resizeMode="cover" style={styles.posterImage} source={{uri: `https://ivyooo.com/assets/images/${posterUrl}`}} />}
        <LinearGradient colors={['transparent', 'rgba(0,0,0,0.9)']} style={styles.thumbFade} />
        <Text numberOfLines={1} style={styles.thumbGenre}>{genre}</Text>
      </Pressable>
    )
  }

  return (
    <ReanimatedPressable accessibilityRole="button" accessibilityLabel={`Watch trailer for ${name || genre}`} key={`${genre}-${name}`} onPress={pressCard} onHoverIn={narrow ? undefined : expandCard} onHoverOut={narrow ? undefined : collapseCard} style={[styles.container, narrow ? styles.containerNarrow : styles.slant, animatedStyles]}>
      <View style={narrow ? styles.posterLayerNarrow : styles.posterUpright} pointerEvents="none">
      {!!posterUrl && <Animated.Image accessibilityLabel="" resizeMode='cover' style={styles.posterImage} source={{uri: `https://ivyooo.com/assets/images/${posterUrl}`}} />}
      <LinearGradient
        colors={[colors.background, 'transparent']}
        style={styles.background}
      />
      <LinearGradient
        colors={['transparent', 'rgba(0,0,0,0.88)']}
        style={styles.backgroundBot}
      />
      {!isExpanded && <Animated.Text style={[styles.genre, narrow && styles.genreNarrow]}>{genre}</Animated.Text>}
      </View>
      <View style={narrow ? styles.fill : styles.overlay} pointerEvents="none">
      {/* {isExpanded && <Video
        ref={video}
        // usePoster
        // posterStyle={{width: '100%', height: '100%', resizeMode: 'cover'}}
        // posterSource={{uri: `https://ivyooo.com/assets/images/${posterUrl}`}}
        style={[styles.video, {aspectRatio: defaultScreenRatio}]}
        source={{
          uri: url ? `https://ivyooo.com/assets/trailers/Ainbo_TLR_240p.mp4` : 'https://d23dyxeqlo5psv.cloudfront.net/big_buck_bunny.mp4',
        }}
        shouldPlay={isExpanded}
        onPlaybackStatusUpdate={status => setStatus(() => status)}
        // onReadyForDisplay={updateVideoRatioOnDisplay}
      />} */}
      </View>
      <Animated.Image resizeMode="contain" style={[styles.titleCard, narrow && styles.titleCardNarrow, !narrow && animatedTitleStyles]} source={{uri: `https://ivyooo.com/assets/images/${titleCardUrl}`}} />
      <Animated.View style={[styles.trailer, animatedButtonStyles]}>
        <Ionicons name="play-circle-outline" size={28} color={colors.white} />
        <Text style={styles.trailerText}>WATCH TRAILER</Text>
      </Animated.View>
    </ReanimatedPressable>
  )
}

export default Cards

const styles = StyleSheet.create({
    container: {
        flex: 1,
        marginHorizontal: -10,
        height: '100%',
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#111',
        overflow: 'hidden',
    },
    slant: {
        transform: [{ skewX: '-12deg' }],
    },
    posterFill: {
        position: 'absolute',
        width: '145%',
        height: '145%',
        left: '-22%',
        top: '-22%',
    },
    posterUpright: {
        position: 'absolute',
        width: '280%',
        height: '140%',
        left: '-90%',
        top: '-20%',
        transform: [{ skewX: '12deg' }],
    },
    posterLayerNarrow: {
        ...StyleSheet.absoluteFillObject,
    },
    posterImage: {
        ...StyleSheet.absoluteFillObject,
        width: '100%',
        height: '100%',
    },
    overlay: {
        position: 'absolute',
        top: '8%',
        bottom: '8%',
        left: '22%',
        right: '22%',
        alignItems: 'center',
        justifyContent: 'center',
        transform: [{ skewX: '12deg' }],
    },
    fill: {
        flex: 1,
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
    },
    containerNarrow: {
        width: '100%',
        maxWidth: 420,
        height: 240,
        top: 0,
        marginVertical: 12,
    },
    featured: {
        width: '100%',
        marginHorizontal: 0,
        marginBottom: 0,
    },
    featuredImage: {
        width: '100%',
        backgroundColor: 'transparent',
        overflow: 'hidden',
        justifyContent: 'flex-end',
    },
    heroFade: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
    },
    heroCopy: {
        alignItems: 'center',
        paddingBottom: 28,
        paddingHorizontal: 20,
    },
    heroGenre: {
        color: colors.white,
        fontFamily: displayFont,
        fontSize: 13,
        fontWeight: '600',
        letterSpacing: 2,
        marginBottom: 8,
    },
    featuredTitle: {
        width: '78%',
        height: 84,
        marginBottom: 14,
    },
    featuredButton: {
        minHeight: 44,
        paddingVertical: 8,
        paddingHorizontal: 18,
        backgroundColor: colors.red,
        borderRadius: 40,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    thumb: {
        width: 132,
        height: 198,
        marginRight: 12,
        backgroundColor: '#111',
        overflow: 'hidden',
    },
    thumbFade: {
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        height: 64,
    },
    thumbGenre: {
        position: 'absolute',
        left: 8,
        right: 8,
        bottom: 10,
        color: colors.white,
        fontFamily: displayFont,
        fontSize: 13,
        fontWeight: '600',
        letterSpacing: 0.4,
    },
    image: {
        flex: 1,
        width: '100%',
        height: 500,
    },
    imageNarrow: {
        height: 240,
    },
    mask: {
        backgroundColor: 'black',
        opacity: 0.4,
        ...StyleSheet.absoluteFill,
    },
    genre: {
        color: colors.white,
        fontFamily: displayFont,
        position: 'absolute',
        alignSelf: 'center',
        fontWeight: '600',
        fontSize: 16,
        letterSpacing: 1,
        bottom: 18,
        paddingHorizontal: 8,
    },
    genreNarrow: {
        bottom: 14,
    },
    background: {
        width: '100%',
        height: 30,
        position: 'absolute',
        top: 0,
    },
    backgroundBot: {
        width: '100%',
        height: '38%',
        position: 'absolute',
        bottom: 0,
    },
    video: {
        alignSelf: 'center',
        width: window.width,
        height: window.height,
        aspectRatio: window.width / window.height,
        left: 0,
        right: 0,
        backgroundColor: 'yellow'
    },
    titleCard: {
        height: 132,
        width: 240,
        alignSelf: 'center',
        zIndex: 2,
    },
    titleCardNarrow: {
        width: '78%',
        height: 96,
        position: 'absolute',
    },
    trailer: {
      position: 'absolute',
      top: '50%',
      marginTop: 78,
      zIndex: 4,
      paddingVertical: 8,
      paddingHorizontal: 14,
      backgroundColor: colors.red,
      borderRadius: 40,
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    trailerText: {
      color: colors.white,
      fontFamily: displayFont,
      paddingLeft: 6,
      fontWeight: '600',
      letterSpacing: 0.4,
    }
})